import { BehaviorSubject } from 'rxjs'
import { PlaceInAkixiNameSpace } from '../../utils/Utils'
import { RxJS } from './RxJS'
import { ReportListResponse, ReportListState, RxJSStateDefinable } from '../Types/Types'
import { retrieveReportList } from '../API/Reporting'

// eslint-disable-next-line
const reportListUpdateSubject: BehaviorSubject<ReportListState> = new BehaviorSubject<ReportListState>({
    isLoading: true
})

RxJS.reportListUpdate = RxJS.reportListUpdate ?? {
    subject: reportListUpdateSubject,
    observable: reportListUpdateSubject.asObservable(),
    announce: (update?: ReportListState): void => {
        if (update) {
            reportListUpdateSubject.next(update)
        }
    }
}

export const reportListUpdate$: RxJSStateDefinable<ReportListState> = RxJS.reportListUpdate

// Retrieves the report list and announces to subscribers.
export const fetchReportList = (reportID?: string, reportDesc?: string): Promise<void> => {
    reportListUpdate$.announce({ isLoading: true })

    return retrieveReportList()
        .then(
            (reportList: Definable<ReportListResponse>): ReportListState => ({
                ReportID: reportID,
                ReportDesc: reportDesc,
                ReportList: reportList?.ReportList
            })
        )
        .then(reportListUpdate$.announce)
}

PlaceInAkixiNameSpace('fetchReportList', fetchReportList)
